import React from 'react';
import { COOKIE_TEXT } from '../text';

function CookiePolicyLink({ url, className = '' }) {
    return (
        <a className={className} href={url} target="_blank" rel="noopener noreferrer">
            {COOKIE_TEXT.policyLink}
        </a>
    );
}

export default CookiePolicyLink;
